/* global axios */
import ApiClient from './ApiClient';

class KanbanAPI extends ApiClient {
  constructor() {
    super('kanban_pipelines', { accountScoped: true });
  }

  getPipelines() {
    return axios.get(this.url);
  }

  createPipeline(data) {
    return axios.post(this.url, data);
  }

  updatePipeline(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  deletePipeline(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getCards(pipelineId, filters = {}) {
    return axios.get(`${this.baseUrl()}/kanban_cards`, {
      params: { pipeline_id: pipelineId, ...filters },
    });
  }

  createCard(data) {
    return axios.post(`${this.baseUrl()}/kanban_cards`, data);
  }

  moveCard(
    cardId,
    columnId,
    position,
    { lossReason, cancelReason, waitingReason, afterCardId } = {}
  ) {
    return axios.put(`${this.baseUrl()}/kanban_cards/${cardId}/move`, {
      column_id: columnId,
      position,
      // null = topo da etapa; undefined não vai no JSON e o backend usa position
      after_card_id: afterCardId,
      loss_reason: lossReason,
      cancel_reason: cancelReason,
      waiting_reason: waitingReason,
    });
  }

  updateCard(cardId, data) {
    return axios.patch(`${this.baseUrl()}/kanban_cards/${cardId}`, data);
  }

  deleteCard(cardId) {
    return axios.delete(`${this.baseUrl()}/kanban_cards/${cardId}`);
  }

  getTrash(pipelineId) {
    return axios.get(`${this.baseUrl()}/kanban_cards/trash`, {
      params: { pipeline_id: pipelineId },
    });
  }

  restoreCard(cardId) {
    return axios.post(`${this.baseUrl()}/kanban_cards/${cardId}/restore`);
  }

  listActivities(cardId) {
    return axios.get(`${this.baseUrl()}/kanban_cards/${cardId}/activities`);
  }

  revertActivity(cardId, activityId) {
    return axios.post(
      `${this.baseUrl()}/kanban_cards/${cardId}/activities/${activityId}/revert`
    );
  }

  getOpportunityAttributes() {
    return axios.get(`${this.baseUrl()}/custom_attribute_definitions`, {
      params: { attribute_model: 'opportunity_attribute' },
    });
  }

  getCard(cardId) {
    return axios.get(`${this.baseUrl()}/kanban_cards/${cardId}`);
  }

  getCardsByContact(contactId) {
    return axios.get(`${this.baseUrl()}/kanban_cards`, {
      params: { contact_id: contactId },
    });
  }

  bulkUpdate(ids, data) {
    return axios.patch(`${this.baseUrl()}/kanban_cards/bulk_update`, {
      ids,
      ...data,
    });
  }

  bulkLabel(ids, label, action) {
    return axios.patch(`${this.baseUrl()}/kanban_cards/bulk_label`, {
      ids,
      label,
      label_action: action,
    });
  }

  bulkDestroy(ids) {
    return axios.delete(`${this.baseUrl()}/kanban_cards/bulk_destroy`, {
      data: { ids },
    });
  }

  bulkCreateTask(ids, task) {
    return axios.post(`${this.baseUrl()}/kanban_cards/bulk_create_task`, {
      ids,
      ...task,
    });
  }

  bulkCreateNote(ids, content) {
    return axios.post(`${this.baseUrl()}/kanban_cards/bulk_create_note`, {
      ids,
      content,
    });
  }

  importCards(formData) {
    return axios.post(`${this.baseUrl()}/kanban_card_imports`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  renameOptionValue(fieldKey, oldLabel, newLabel) {
    return axios.patch(`${this.baseUrl()}/kanban_cards/rename_option_value`, {
      field_key: fieldKey,
      old_label: oldLabel,
      new_label: newLabel,
    });
  }
}

export default new KanbanAPI();
